<template>
    <v-flex xs12 sm12 md10 lg8 offset-md1 offset-lg2 style="position:relative;">

        <v-flex xs12>

            <carousel v-if="(banners && banners.length > 0)" :perPage=1 :autoplay=true :paginationEnabled=false :loop=true :speed=1000 :autoplayTimeout=4000 ease=true>

                <slide v-for="(banner, i) in banners" :key="banner.id" :index="i">

                    <img v-if="banner.type == 'Image'" :src="banner.value" width="100%;" height="auto"/>

                    <!-- style="height: 100%;" to remove the m]gaps on the bottom of the video caoursel -->

                    <video v-else width="100%;" height="auto" controls playsinline autoplay muted loop style="height: 100%;">

                        <source :src="banner.value" type="video/mp4">

                        <source :src="banner.value" type="video/webm">

                        <source :src="banner.value" type="video/ogg">

                    </video>

                </slide>

            </carousel>

        </v-flex>

        <Jackpot/>

    </v-flex>

</template>

<style scoped>
.v-image__image--cover {
    background-size: 100% auto !important;
    min-height: 100%;
}

</style>

<script>
import Api from "@/api";
import { Carousel, Slide } from 'vue-carousel';
import Jackpot from '@/components/HomePage/Jackpot';

export default {
    // https://stackoverflow.com/questions/51067412/changing-the-vuetify-carousel-height
    data() {
        return {
            // carouselHeight: 0
            banners: null
        }
    },
    mounted () {
        // this.getCarouselHeight()
        this.getBanners();
    },
    components: {
        Carousel,
        Slide,
        Jackpot
    },
    methods: {
        async getBanners() {

            let res = await Api.getBanners();

            var bannerArray = null;

            if (res && 'success' in res && res.success === true) {

                bannerArray = res.data.map(item => {

                    let temp = item.value.split('.');

                    if(temp[temp.length-1].toLowerCase() === 'jpg' || temp[temp.length-1].toLowerCase() === 'png' || temp[temp.length-1].toLowerCase() === 'gif' || temp[temp.length-1].toLowerCase() === 'jpeg'){

                        item.type = 'Image';

                        return item;

                    } else if (temp[temp.length-1].toLowerCase() === 'mp4' || temp[temp.length-1].toLowerCase() === 'webm'|| temp[temp.length-1].toLowerCase() === 'ogg'){

                        item.type = 'Video';

                        return item;

                    } else {

                        item.type = 'Unkown';
                        return item;
                    }

                });

                this.banners =  bannerArray.filter(banner => banner.type != 'Unkown');
            }
        }
    }
}
</script>

